module.exports = __webpack_public_path__ + "img/question11c1.bfa3d792.png";